// extracted by mini-css-extract-plugin
module.exports = {"navigationTabs":"NavigationTabs_navigationTabs__22QUR","tab":"NavigationTabs_tab__1HOCU","isActive":"NavigationTabs_isActive__3PxP4"};